import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'components/ui';
import remixStep1 from 'img/remix-step-1.svg';
import remixStep2 from 'img/remix-step-2.svg';
import remixStep3 from 'img/remix-step-3.svg';
import remixStep4 from 'img/remix-step-4.svg';
import remixStep5 from 'img/remix-step-5.svg';
import remixStep6 from 'img/remix-step-6.svg';
import chevronUp from 'img/chevron-up.svg';
import chevronDown from 'img/chevron-down.svg';

const Header = styled(Flex)`
  cursor: pointer;
`;

const RemixStudioHelp = ({ initialOpen }) => {
  const [open, setOpen] = useState(initialOpen);

  const toggleOpen = () => {
    setOpen(open => !open);
  };

  useEffect(() => {
    setOpen(initialOpen);
  }, [initialOpen]);

  return (
    <Box mt={2} height="364px">
      <Header
        onClick={toggleOpen}
        fontSize="20px"
        fontWeight="bold"
        justifyBetween
        p={3}
        backgroundColor="black"
        borderTopLeftRadius="8px"
        borderTopRightRadius="8px"
        borderBottomLeftRadius={open ? '0px' : '8px'}
        borderBottomRightRadius={open ? '0px' : '8px'}
      >
        <Box>How to remix Futura Mixes with Remix Studio</Box>
        <Box>
          <img src={open ? chevronUp : chevronDown} alt="toggle" width="14px" />
        </Box>
      </Header>

      {open && (
        <Box
          px={3}
          pb={3}
          backgroundColor="black"
          borderBottomLeftRadius="8px"
          borderBottomRightRadius="8px"
        >
          <Box fontSize="12px" fontWeight={1} mb={2}>
            Follow these steps to create your own Futura Remix from the Mixes in your collection.
            You will need at least two Futura Mixes to create a Remix.
          </Box>
          <Box mt={3} fontSize="12px">
            <Flex my={2} alignCenter>
              <Box mr={2}>
                <img src={remixStep1} alt="1" width="32px" />
              </Box>
              <Box>Select a source for Input A from your collection of Futura Mixes.</Box>
            </Flex>

            <Flex my={2} alignCenter>
              <Box mr={2}>
                <img src={remixStep2} alt="2" width="32px" />
              </Box>
              <Box>Select a source for Input B from your collection of Futura Mixes.</Box>
            </Flex>

            <Flex my={2} alignCenter>
              <Box mr={2}>
                <img src={remixStep3} alt="3" width="32px" />
              </Box>
              <Box>
                Within the clips matrix, select the clip from each input source that you’d like to
                use for each section of your Futura Remix.
              </Box>
            </Flex>

            <Flex my={2} alignCenter>
              <Box mr={2}>
                <img src={remixStep4} alt="4" width="32px" />
              </Box>
              <Box>
                Preview the audio and visuals, and adjust your clips selections until your Remix
                looks and sounds just right.
              </Box>
            </Flex>

            <Flex my={2} alignCenter>
              <Box mr={2}>
                <img src={remixStep5} alt="5" width="32px" />
              </Box>
              <Box>
                Select your burn preferences for the input sources if you’d you want to discount
                your minting price for the Remix
              </Box>
            </Flex>

            <Flex my={2} alignCenter>
              <Box mr={2}>
                <img src={remixStep6} alt="6" width="32px" />
              </Box>
              <Box>Mint and enjoy your new Futura Remix!</Box>
            </Flex>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default RemixStudioHelp;
